import * as React from "react";
import { NameView, InfoViewGrid1, InfoViewGrid2, PriceView, OriginalPriceView, LTTitleIconView, CollectViewOrange, CollectViewTomato, InfoBottomStyle2, NameViewWithTag, InfoBottomLeftText, InfoViewGridBase, } from "./styles";
import { ModuleLayoutStyle } from "../../../services/playground";
import { CommentStarForM } from "../../../components/CommentStar";
import { isValidNumber } from "../../../utils/number";
import { ActTagViewForM } from "../ActTagViews";
export const ProductInfoGrid1 = (props) => {
    const { name, price, originalPrice, titleIcon, collect, actTags, layoutStyle } = props;
    if (layoutStyle === ModuleLayoutStyle.Orange) {
        return (React.createElement(InfoViewGrid1, null,
            React.createElement("section", null,
                NameViewGrid(name, 1),
                PriceViews({
                    price,
                    columnNum: 1,
                    originPrice: originalPrice,
                    className: "orangePrice",
                }),
                actTags && React.createElement(ActTagViewForM, { actTags: actTags })),
            React.createElement(InfoBottomStyle2, { gridCol: 1 },
                isValidNumber(collect === null || collect === void 0 ? void 0 : collect.score) ? (React.createElement(CommentStarForM, { rateScore: +((collect === null || collect === void 0 ? void 0 : collect.score) || 0) })) : (React.createElement(InfoBottomLeftText, null, collect === null || collect === void 0 ? void 0 : collect.score)),
                collect && CollectViews({ collect, columnNum: 1, layoutStyle }))));
    }
    return (React.createElement(InfoViewGrid1, null,
        NameViewGrid(name, 1),
        PriceViews({ price, columnNum: 1, className: "tomatoPrice" }),
        originalPrice && originalPrice !== price && OriginalPriceViews(originalPrice),
        React.createElement(InfoBottomStyle2, { gridCol: 1 },
            titleIcon && LTTitleIconViews(titleIcon),
            collect && CollectViews({ collect, columnNum: 1, layoutStyle }))));
};
export const ProductInfoGrid2 = (props) => {
    const { name, price, originalPrice, collect, titleIcon, isRollable, layoutStyle } = props;
    if (layoutStyle === ModuleLayoutStyle.Orange) {
        return (React.createElement(InfoViewGrid2, null,
            NameViewGrid(name, 2, titleIcon),
            PriceViews({
                price,
                columnNum: 2,
                originPrice: originalPrice,
                className: "orangePrice",
            }),
            !!isRollable ? null : (React.createElement(InfoBottomStyle2, { gridCol: 2 },
                isValidNumber(collect === null || collect === void 0 ? void 0 : collect.score) ? (React.createElement(CommentStarForM, { rateScore: +((collect === null || collect === void 0 ? void 0 : collect.score) || 0) })) : (React.createElement(InfoBottomLeftText, null, collect === null || collect === void 0 ? void 0 : collect.score)),
                collect && CollectViews({ collect, columnNum: 2, layoutStyle })))));
    }
    return (React.createElement(InfoViewGrid2, null,
        NameViewGrid(name, 2),
        PriceViews({ price, columnNum: 2, className: "tomatoPrice" }),
        React.createElement(InfoBottomStyle2, { gridCol: 2 },
            originalPrice && originalPrice !== price && OriginalPriceViews(originalPrice),
            collect && CollectViews({ collect, columnNum: 2, layoutStyle }))));
};
export const ProductInfoGrid3 = (props) => {
    const { price, layoutStyle } = props;
    if (layoutStyle === ModuleLayoutStyle.Orange) {
        return (React.createElement(InfoViewGridBase, null, PriceViews({ price, columnNum: 3, className: "orangePrice" })));
    }
    return (React.createElement(InfoViewGridBase, null, PriceViews({ price, columnNum: 3, className: "tomatoPrice" })));
};
const NameViewGrid = (name, columnNum, titleTag) => {
    return (React.createElement(NameView, { gridCol: columnNum },
        titleTag && React.createElement(NameViewWithTag, { src: titleTag }),
        name));
};
const PriceViews = ({ price, columnNum, originPrice, className = "" }) => {
    return (React.createElement(PriceView, { gridCol: columnNum, className: className },
        price,
        originPrice && originPrice !== price && (React.createElement(OriginalPriceView, { style: { marginLeft: "0.25rem" } }, originPrice))));
};
const OriginalPriceViews = (originalPrice) => {
    return React.createElement(OriginalPriceView, null, originalPrice);
};
const LTTitleIconViews = (titleIcon) => {
    return titleIcon && React.createElement(LTTitleIconView, { src: titleIcon });
};
const CollectViews = ({ collect, columnNum, layoutStyle = ModuleLayoutStyle.Orange, }) => {
    if (layoutStyle === ModuleLayoutStyle.Orange) {
        return React.createElement(CollectViewOrange, null, collect === null || collect === void 0 ? void 0 : collect.text);
    }
    return (React.createElement(CollectViewTomato, { gridCol: columnNum },
        React.createElement("img", { src: "https://i.ezbuy.sg/FnMkXCrG8u2d7PImYx0W5gh53i15" }),
        (collect === null || collect === void 0 ? void 0 : collect.text) && React.createElement("span", null, collect.text)));
};
